import '@babel/polyfill';

// jQuery
// import $ from 'jquery';

// Jsモジュール
/* eslint-disable */
import { ScrollTop } from './modules/scrollTop';
import { TelLink } from './modules/telLink';
//import { HumbergerMenu } from './modules/humbergerMenu';
/* eslint-disable */

// メインビジュアル
let swipeOption = {
  loop: true,
  effect: 'fade',
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  speed: 2000,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

// 取扱実績
if (document.getElementsByClassName('swiper-container-result')[0] != null) {
  var swiper = new Swiper('.swiper-container-result', {
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 10,
    speed: 600,
    autoplay: { delay: 3000 },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    breakpoints: {
      500: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      767: {
        slidesPerView: 3.2,
        spaceBetween: 10,
      },
      851: {
        slidesPerView: 4.2,
        spaceBetween: 20,
      },
      1000: {
        slidesPerView: 4.2,
        spaceBetween: 30,
      },
    },
  });
}

var controller = new ScrollMagic.Controller({
  globalSceneOptions: {
    duration: 100,
    triggerHook: 'onEnter',
  },
});

if (document.getElementsByClassName('top')[0] != null) {
  new ScrollMagic.Scene({ triggerElement: '.concept' })
    .on('enter', function (e) {
      document.getElementsByClassName('content-img-concept')[0].classList.add('active');
      document.getElementsByClassName('ttls-concept')[0].classList.add('fadein-active');
    })
    .addTo(controller);

  new ScrollMagic.Scene({ triggerElement: '.concept-dl' })
    .on('enter', function (e) {
      document.getElementsByClassName('concept-dl')[0].classList.add('faadein-scroll-active');
    })
    .addTo(controller);

  new ScrollMagic.Scene({ triggerElement: '.about' })
    .on('enter', function (e) {
      document.getElementsByClassName('content-img-about')[0].classList.add('active');
      document.getElementsByClassName('ttls-about')[0].classList.add('fadein-active');
    })
    .addTo(controller);

  // new ScrollMagic.Scene({ triggerElement: '.lead-about' })
  //   .on('enter', function (e) {
  //     document.getElementsByClassName('lead-about')[0].classList.add('faadein-scroll-active');
  //   })
  //   .addTo(controller);

  new ScrollMagic.Scene({ triggerElement: '.about-text' })
    .on('enter', function (e) {
      document.getElementsByClassName('about-text')[0].classList.add('faadein-scroll-active');
    })
    .addTo(controller);

  new ScrollMagic.Scene({ triggerElement: '.works' })
    .on('enter', function (e) {
      document.getElementsByClassName('ttls-works')[0].classList.add('fadein-active');
    })
    .addTo(controller);

  new ScrollMagic.Scene({ triggerElement: '.contents-works' })
    .on('enter', function (e) {
      document.getElementsByClassName('contents-works')[0].classList.add('faadein-scroll-active');
    })
    .addTo(controller);

  new ScrollMagic.Scene({ triggerElement: '.contents-foot-contact' })
    .on('enter', function (e) {
      document.getElementsByClassName('contents-foot-contact')[0].classList.add('faadein-scroll-active');
    })
    .addTo(controller);

  new ScrollMagic.Scene({ triggerElement: '.result' })
    .on('enter', function (e) {
      document.getElementsByClassName('ttls-result')[0].classList.add('fadein-active');
    })
    .addTo(controller);

  new ScrollMagic.Scene({ triggerElement: '.swiper-container-result' })
    .on('enter', function (e) {
      document.getElementsByClassName('swiper-container-result')[0].classList.add('faadein-scroll-active');
      document.getElementsByClassName('swiper-container-result')[0].classList.add('swiper-container-result-active');
    })
    .addTo(controller);
}

// Barba
$(window).on('load', function () {
  var animationEvt = 'webkitAnimationEnd mozAnimationEnd msAnimationEnd oAnimationEnd animationEnd',
    hasAnimationEvt = 'AnimationEvent' in window;

  var location = window.location.href;
  if (location !== 'http://localhost/sora/') {
    $('._move').addClass('moved');
    $('.wrap').css('visibility', 'visible');
    $('.wrap').addClass('fade-in');

    if (hasAnimationEvt) {
      $('._move').on(animationEvt, function () {
        $('._move').removeClass('moved');
      });
    }
  } else {
    $('body').css('backgroundColor', 'black');
    $('.anim').removeAttr('style');
    $('body').css({ overflowY: 'hidden', height: '100vh' });

    if (hasAnimationEvt) {
      $('.openning-anim1').on(animationEvt, function () {
        $(this).remove();
        $('.wrap').css('visibility', 'visible');
        $('body').css('backgroundColor', 'transparent');
      });
    }

    if (hasAnimationEvt) {
      $('.openning-anim2').on(animationEvt, function () {
        if (document.getElementsByClassName('swiper-container')[0] != null) {
          new Swiper('.swiper-container-mainvisual', swipeOption);
        }

        $('body').removeAttr('style');
        $('body').css('backgroundColor', 'transparent');
      });
    }
  }
});

$(function () {
  $('input[type="text"], input[type="email"], textarea').addClass('form-control');

  var $win = $(window),
    $main = $('main'),
    $nav = $('header'),
    navHeight = $nav.outerHeight(),
    navPos = $nav.offset().top,
    fixedClass = 'is-fixed';

  $win.on('load scroll', function () {
    var value = $(this).scrollTop();
    if (value > navPos) {
      $nav.addClass(fixedClass);
      $main.css('margin-top', navHeight);
    } else {
      $nav.removeClass(fixedClass);
      $main.css('margin-top', '0');
    }
  });

  $('.nav-toggle').click(function () {
    $(this).toggleClass('active');

    if ($(this).hasClass('active')) {
      $('.sp-nav').addClass('active');
    } else {
      $('.sp-nav').removeClass('active');
    }
  });

  $('.sp-nav a').wrapInner('<span>');

  $('.menu-item-has-children')
    .mouseover(function () {
      $(this).next().css('display', 'block');
    })
    .mouseout(function () {
      $(this).next().removeAttr('style');
    });

  $('.menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();
    var $subNav = $(this).next('.sub-menu');
    if ($subNav.css('display') === 'none') {
      $(this).addClass('is-active');
      $subNav.fadeIn();
    } else {
      $(this).removeClass('is-active');
      $subNav.fadeOut();
    }
  });

  if ($('.jQueryAutoHeight').length !== 0) {
    $('.jQueryAutoHeight').autoHeight();
  }

  function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  var id = getParam('id');
  var animationEvt = 'webkitAnimationEnd mozAnimationEnd msAnimationEnd oAnimationEnd animationEnd',
    hasAnimationEvt = 'AnimationEvent' in window;

  if (id === 'acquisition') {
    var target = $('#acquisition');
    var position = target.offset().top;
    if (hasAnimationEvt) {
      $('._move').on(animationEvt, function () {
        $('body, html').animate({ scrollTop: position }, 300, 'swing');
      });
    }
  }
});
